/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationStatesDropdown200,
  GetApiV1LocationStatesDropdown401,
  GetApiV1LocationStatesDropdown500,
  GetApiV1LocationStatesDropdownQueryParams,
  GetApiV1LocationStatesDropdownQueryResponse,
} from "../../types/locationStateController/GetApiV1LocationStatesDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1LocationStatesDropdownQueryParamsSchema = z
  .object({
    countryId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1LocationStatesDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationStatesDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1LocationStatesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationStatesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStatesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationStatesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStatesDropdown500>;

export const getApiV1LocationStatesDropdownQueryResponseSchema = z.lazy(
  () => getApiV1LocationStatesDropdown200Schema,
) as unknown as ToZod<GetApiV1LocationStatesDropdownQueryResponse>;
